import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Tag } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import portfolioData from '../data/portfolio.json';

const Portfolio = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page-portfolio">
      <section className="portfolio-hero">
        <div className="portfolio-hero-container">
          <h1 className="page-title">{t('portfolio.pageTitle')}</h1>
          <p className="page-subtitle">
            {t('portfolio.pageSubtitle')}
          </p>
        </div>
      </section>

      <section className="portfolio-catalog">
        <div className="portfolio-container">
          <div className="portfolio-grid">
            {portfolioData.map((project) => (
              <Link 
                key={project.id} 
                to={`/portfolio/${project.slug}`}
                className="portfolio-card"
              >
                <div className="portfolio-card-image">
                  <img src={project.images[0]} alt={project.title} />
                  <div className="portfolio-card-overlay">
                    <div className="portfolio-view-btn">
                      {t('portfolio.viewCase')}
                      <ArrowRight size={18} />
                    </div>
                  </div>
                </div>
                
                <div className="portfolio-card-content">
                  <div className="portfolio-card-tags">
                    {project.tags.slice(0, 2).map((tag, index) => (
                      <span key={index} className="portfolio-tag">
                        <Tag size={12} />
                        {tag}
                      </span>
                    ))}
                  </div>
                  
                  <h3 className="portfolio-card-title">{project.title}</h3>
                  <p className="portfolio-card-description">{project.shortDescription}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="portfolio-cta">
        <div className="portfolio-cta-container">
          <h2 className="portfolio-cta-title">{t('portfolio.ctaTitle')}</h2>
          <p className="portfolio-cta-subtitle">
            {t('portfolio.ctaSubtitle')}
          </p>
          <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
            {t('portfolio.ctaButton')}
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
